document.addEventListener("DOMContentLoaded", function () {
  const wishlist = document.querySelector(".wishlist");
  if (wishlist) {
    const head = wishlist.querySelector(".wishlist__head");

    const toggleWishlist = () => {
      wishlist.classList.toggle("opened");
    };

    head.addEventListener("click", toggleWishlist);

    // Add and remove items to wishlist
    let wishlistBtns = document.querySelectorAll(".wishlist-btn");
    const wishlistList = wishlist.querySelector(".wishlist__list");
    const wishlistItemsCount = wishlist.querySelector(".wishlist__items-count");
    const wishlistMobileItemsCount = wishlist.querySelector(".wishlist__mobile-items-count");
    const modalWishlist = document.querySelector(".modal-callback__wishlist");
    const modalWishlistList = document.querySelector(".modal-callback__wishlist-list");

    // Get cookie by name
    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
    }

    const toggleButtonClass = (btn) => {
      const itemBrand = btn.dataset.wishlistBrand;
      const itemModel = btn.dataset.wishlistModel;
      const itemKit = btn.dataset.wishlistKit;
      const itemArticle = btn.dataset.wishlistArticle;
      const itemMaterial = btn.dataset.wishlistMaterial;
      const itemName = btn.dataset.wishlistName;

      const id = JSON.stringify({ article: itemArticle, material: itemMaterial, name: itemName, brand: itemBrand, model: itemModel, kit: itemKit }).replace(/С/g, "C");

      const existingItems = getCookie("wishlist");
      if (existingItems) {
        const wishlistItems = JSON.parse("[" + existingItems + "]");
        const idString = JSON.stringify({ article: itemArticle, material: itemMaterial, name: itemName, brand: itemBrand, model: itemModel, kit: itemKit }).replace(/С/g, "C");

        if (wishlistItems.some((item) => JSON.stringify(item) === idString)) {
          btn.classList.add("added");
        } else {
          btn.classList.remove("added");
        }
      } else {
        btn.classList.remove("added");
      }
    };

    // Add btns handler (include newly created)
    const addWishlistBtnsHandler = () => {
      wishlistBtns.forEach((btn) => {
        btn.addEventListener("click", updateWishlist);
      });
    };

    const updateWishlist = (e) => {
      let existingItems = getCookie("wishlist");
      let updatedItems = existingItems ? JSON.parse("[" + existingItems + "]") : [];

      updatedItems = updatedItems.map((obj) => JSON.stringify(obj));
      if (e) {
        e.stopPropagation();
        e.preventDefault();
        const itemBrand = e.currentTarget.dataset.wishlistBrand;
        const itemModel = e.currentTarget.dataset.wishlistModel;
        const itemKit = e.currentTarget.dataset.wishlistKit;
        const itemArticle = e.currentTarget.dataset.wishlistArticle;
        const itemMaterial = e.currentTarget.dataset.wishlistMaterial;
        const itemName = e.currentTarget.dataset.wishlistName;

        const id = JSON.stringify({ article: itemArticle, material: itemMaterial, name: itemName, brand: itemBrand, model: itemModel, kit: itemKit }).replace(/С/g, "C");

        if (!updatedItems.includes(id)) {
          updatedItems.push(id);
        } else {
          updatedItems = updatedItems.filter((item) => item !== id);
        }
        let newCookie = `wishlist=${updatedItems.join(",")}; path=/;`;
        newCookie = newCookie.replace(/С/g, "C");
        document.cookie = newCookie;
      }
      wishlistList.innerHTML = "";
      modalWishlistList.innerHTML = "";
      wishlistItemsCount.textContent = updatedItems.length;
      wishlistMobileItemsCount.textContent = updatedItems.length;

      if (updatedItems.length) {
        modalWishlist.classList.remove("hidden");
        wishlist.classList.remove("empty");
        updatedItems.forEach((item) => {
          const itemJSON = JSON.parse(item);
          const newLi = document.createElement("li");

          //update widget
          newLi.classList.add("wishlist__item");
          newLi.innerHTML = `
            <div class="wishlist__item-title">${itemJSON.name}</div>
            <button class="wishlist__item-remove-btn wishlist-btn" data-wishlist-brand="${itemJSON.brand}" data-wishlist-model="${itemJSON.model}" data-wishlist-kit="${itemJSON.kit}" data-wishlist-article="${itemJSON.article}" data-wishlist-material="${itemJSON.material}" data-wishlist-name="${itemJSON.name}">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.6">
                  <rect width="1.81602" height="54.4807" transform="matrix(0.703677 -0.71052 0.703677 0.71052 0.385742 1.29053)" fill="currentColor"></rect>
                  <rect width="1.81602" height="54.4807" transform="matrix(0.703677 0.71052 -0.703677 0.71052 38.3369 0)" fill="currentColor"></rect>
                </g>
              </svg>
            </button>
          `;
          wishlistList.appendChild(newLi);

          //update modal-callback

          const newLiModal = document.createElement("li");
          newLiModal.classList.add("modal-callback__wishlist-item");
          newLiModal.innerHTML = `
          <input type="text" readonly="" value="${itemJSON.name}" name="wishlist[]">
          <button class="modal-callback__wishlist-remove-btn wishlist-btn" data-wishlist-brand="${itemJSON.brand}" data-wishlist-model="${itemJSON.model}" data-wishlist-kit="${itemJSON.kit}" data-wishlist-article="${itemJSON.article}" data-wishlist-material="${itemJSON.material}" data-wishlist-name="${itemJSON.name}">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.6">
          <rect width="1.81602" height="54.4807" transform="matrix(0.703677 -0.71052 0.703677 0.71052 0.385742 1.29053)" fill="currentColor"></rect>
          <rect width="1.81602" height="54.4807" transform="matrix(0.703677 0.71052 -0.703677 0.71052 38.3369 0)" fill="currentColor"></rect>
          </g>
          </svg>
          </button>
        `;
          modalWishlistList.appendChild(newLiModal);
        });
        wishlistBtns = document.querySelectorAll(".wishlist-btn");
        addWishlistBtnsHandler();
      } else {
        modalWishlist.classList.add("hidden");
        wishlist.classList.add("empty");
        wishlist.classList.remove("opened");
      }
      updateButtons();
    };

    const updateButtons = () => {
      wishlistBtns.forEach((btn) => {
        toggleButtonClass(btn);
      });
    };

    updateWishlist();
    addWishlistBtnsHandler();
  }
});
